export const VISIT_PAGE_CONSTANTS = {
  COLUMN_SEPARATOR_WIDTH: 28,
};
